const ENTITY_LISTS: { root: string; keep: string[] }[] = [
  { root: '/imoveis/proprietarios', keep: ['novo'] },
  { root: '/imoveis/captacoes', keep: [] },
  { root: '/imoveis', keep: ['novo-imovel', 'chaves', 'proprietarios', 'captacoes'] },
  { root: '/clientes', keep: ['novo-cliente'] },
  { root: '/contratos', keep: ['novo'] },
  { root: '/financeiro', keep: [] },
  { root: '/documentos/modelos', keep: ['novo'] },
  { root: '/crm', keep: [] },
  { root: '/chat', keep: [] },
  { root: '/blog', keep: ['novo'] }
]

const SETTINGS_PATH = /^\/empresas\/[^/]+\/configuracoes(\/.*)?$/

export function routeAfterCompanySwitch(pathname: string, nextCompanyId: string): string {
  const settings = SETTINGS_PATH.exec(pathname)
  if (settings) return `/empresas/${nextCompanyId}/configuracoes${settings[1] ?? ''}`
  for (const { root, keep } of ENTITY_LISTS) {
    if (!pathname.startsWith(`${root}/`)) continue
    const segment = pathname.slice(root.length + 1).split('/')[0]
    if (!segment || keep.includes(segment)) return pathname
    return root
  }
  return pathname
}
